import { useQuery } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { queryKeys } from './queryKeys';

/**
 * Query hook to fetch a public conversation by ID (no authentication required)
 * Used on the /share/conversation/[id] page
 */
export const usePublicConversationQuery = (id: string | null) => {
	return useQuery({
		queryKey: queryKeys.publicConversations.detail(id!),
		queryFn: async () => {
			const { data, error } = await ApiService.GetPublicConversation(id!);
			if (error || !data) {
				throw new Error(error?.message || 'Failed to fetch public conversation');
			}
			return data;
		},
		enabled: !!id
	});
};
